// ============================================================================
// post-client-mod -- useUpdatePost Hook
//
// 更新文章的 mutation hook。
// ============================================================================
import { useState, useCallback } from 'react';
import { getPostApiClient } from '../post-api-client.js';
/**
 * 更新文章
 */
export function useUpdatePost() {
    const [post, setPost] = useState(null);
    const [updating, setUpdating] = useState(false);
    const [error, setError] = useState(null);
    const updatePost = useCallback(async (id, params) => {
        setUpdating(true);
        setError(null);
        try {
            const result = await getPostApiClient().updatePost(id, params);
            setPost(result);
            return result;
        }
        catch (err) {
            const message = err instanceof Error ? err.message : '更新文章失败';
            setError(message);
            return null;
        }
        finally {
            setUpdating(false);
        }
    }, []);
    const reset = useCallback(() => {
        setPost(null);
        setError(null);
    }, []);
    return { post, updating, error, updatePost, reset };
}
//# sourceMappingURL=use-update-post.js.map